import Carousel from 'shared/carousel/carousel'

const homepagePeopleInNewsCarousel = document.getElementById('homepagePeopleInNews-carousel')
if (homepagePeopleInNewsCarousel) {
	const carousel = new Carousel({
		element: homepagePeopleInNewsCarousel,
		itemsToScrollBy: 2
	})
	carousel.init()
}
